import { ICONS } from '../icons';

/** Render a vendored Lucide icon as an inline SVG string. '' for unknown names. */
export function iconSvg(name: string, size = 18, cls = ''): string {
  const inner = ICONS[name];
  if (!inner) return '';
  return `<svg class="icon${cls ? ` ${cls}` : ''}" width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${inner}</svg>`;
}

export function hasIcon(name: string): boolean {
  return Object.prototype.hasOwnProperty.call(ICONS, name);
}
